<template>
  <div class="circular">
    <router-link :to="router">
      <img class="contained" :src="imgurl" :alt="alt"></img>
      <div class="gt-xs overlay">
        <h3>{{caption}}</h3>
      </div>

      <div class="lt-sm overlay-mobile">
        <h4>{{caption}}</h4>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'circular-image',
  props: ['imgurl', 'caption', 'alt', 'router']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.circular
  height: 100%
  width: 100%
  border-radius: 50%
  background-color: red
  overflow: hidden
  position: relative

.contained
  object-fit: contain
  display: block
  margin: 0 auto
  vertical-align: middle

.overlay
  background: rgba(0,0,0,0)
  height: 100%
  width: 100%
  position: absolute
  border-radius: 50%
  top: 0px
  left: 0px
  transition: 0.5s

.overlay h3
  opacity: 0
  color: white
  text-align: center
  vertical-align: bottom
  top: 60%
  position: relative
  transition: 0.5s

.overlay:hover
  background: rgba(0, 0, 0, 0.5)
  transition: 0.5s

.overlay:hover h3
  opacity: 1
  transition: 0.5s

.overlay-mobile
  background: rgba(0,0,0,0.5)
  height: 100%
  position: absolute
  width: 100%
  border-radius: 50%
  top: 0px
  left: 0px

.overlay-mobile h4
  color: white
  text-align: center
  vertical-align: bottom
  top: 50%
  position: relative
</style>



// WEBPACK FOOTER //
// CircularImage.vue?e465384c